import querystring from 'query-string'
import { isValidObject } from './object'
import { isUndefinedOrEmpty } from '@afterpay/utils/string'
import { useShippingOption, useCheckoutState, useConsumerSelector, useIsExpress, useShippingAddress, useIsMCP, useCallbackUrlQueryArgs } from '../state'
import { ContactAddress, transformAddressToContact } from './address'

import { Money } from '@afterpay/types'

interface TransactionMessageOrderInfoConsumer {
  email?: string
  givenNames?: string
  surname?: string
}

interface TransactionMessageShippingOption {
  shippingOptionIdentifier: string
}
interface TransactionMessageOrderInfo {
  amount?: Money
  consumer: TransactionMessageOrderInfoConsumer
  shippingAddress?: ContactAddress
  shippingOption?: TransactionMessageShippingOption
}
export interface TransactionMessage {
  orderInfo?: TransactionMessageOrderInfo
  [queryArgKey: string]: any
}

export const useTransactionMessage = (): TransactionMessage => {
  const { started } = useCheckoutState()
  const queryArgs = useCallbackUrlQueryArgs()
  const message = querystring.parse(queryArgs, { decode: false })
  const shippingAddress = useShippingAddress()
  const consumer = useConsumerSelector()
  const shippingOption = useShippingOption()
  const isExpress = useIsExpress()
  const isMCP = useIsMCP()

  const hasValidShippingAddress = isValidObject(shippingAddress?.chosenAddress)
  const hasValidBillingAddress = isValidObject(consumer?.profile?.contactAddress)
  const shippingOptionIdentifier = shippingOption?.selectedShippingOption?.id
  const hasShippingOption = !isUndefinedOrEmpty(shippingOptionIdentifier)

  const orderInfo = {
    ...(isExpress && {
      ...(hasValidShippingAddress && {
        shippingAddress: {
          ...transformAddressToContact(shippingAddress.chosenAddress),
        },
      }),
      ...(hasShippingOption && {
        shippingOption: {
          shippingOptionIdentifier,
        },
      }),
    }),
    amount: isMCP ? started?.consumerAmount : started?.merchantAmount,
    consumer: {
      ...(!hasValidShippingAddress && { phoneNumber: consumer?.profile?.phoneNumber }),
      email: consumer?.email,
      givenNames: consumer?.profile?.givenNames,
      surname: consumer?.profile?.surname,
    },
  }
  return {
    ...message,
    ...((hasValidShippingAddress || hasValidBillingAddress) && { orderInfo }),
  }
}
